import { Link } from "react-router-dom";

const articles = [
  {
    title: "Guia Completo: Como Usar Hoobuy Spreadsheet",
    url: "/hoobuy-spreadsheet-guia",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20desk%20with%20silver%20laptop%20showing%20colorful%20data%20charts%2C%20next%20to%20a%20ceramic%20coffee%20cup%20and%20small%20succulent%20plant%2C%20morning%20sunlight%20streaming%20through%20window%2C%20clean%20professional%20atmosphere%2C%20no%20text&width=800&height=500&seq=artc-grid-01&orientation=landscape"
  },
  {
    title: "Hoobuy vs Pandabuy: Qual Escolher em 2026",
    url: "/hoobuy-vs-pandabuy",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20contrasting%20luxury%20sneakers%20placed%20facing%20each%20other%20on%20smooth%20concrete%20surface%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20editorial%20fashion%20photography%2C%20minimal%20composition%2C%20no%20text&width=800&height=500&seq=artc-grid-02&orientation=landscape"
  },
  {
    title: "Melhor Agente de Compras da China 2026",
    url: "/melhor-agente-2026",
    imageUrl: "https://readdy.ai/api/search-image?query=Top%20down%20view%20of%20elegant%20shopping%20essentials%20including%20a%20leather%20wallet%20designer%20watch%20and%20gold%20rings%20scattered%20on%20white%20linen%2C%20bright%20natural%20lighting%2C%20luxury%20editorial%2C%20no%20text&width=800&height=500&seq=artc-grid-03&orientation=landscape"
  },
  {
    title: "Segurança no Hoobuy: Dicas Essenciais",
    url: "/seguranca-hoobuy",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20photography%20of%20a%20small%20brass%20padlock%20placed%20next%20to%20a%20designer%20handbag%20on%20white%20marble%2C%20soft%20afternoon%20light%2C%20shallow%20depth%20of%20field%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=artc-grid-04&orientation=landscape"
  },
  {
    title: "Como Encontrar os Melhores Links no Hoobuy",
    url: "/melhores-links-hoobuy",
    imageUrl: "https://readdy.ai/api/search-image?query=Pair%20of%20stylish%20round%20glasses%20resting%20on%20an%20open%20leather%20notebook%20with%20a%20mechanical%20pencil%2C%20placed%20on%20light%20oak%20desk%2C%20warm%20indoor%20lighting%2C%20cozy%20editorial%20feel%2C%20no%20text&width=800&height=500&seq=artc-grid-05&orientation=landscape"
  },
  {
    title: "Nike no Hoobuy: Guia de Tênis e Modelos",
    url: "/nike-hoobuy-guia",
    imageUrl: "https://readdy.ai/api/search-image?query=Single%20iconic%20white%20sneaker%20with%20red%20accents%20displayed%20on%20clear%20acrylic%20stand%2C%20gallery%20spotlight%20effect%2C%20minimal%20product%20photography%2C%20dramatic%20contrast%2C%20clean%20background%2C%20no%20text&width=800&height=500&seq=artc-grid-06&orientation=landscape"
  },
  {
    title: "Jordan no Hoobuy: Modelos Mais Procurados",
    url: "/jordan-hoobuy-modelos",
    imageUrl: "https://readdy.ai/api/search-image?query=High%20top%20basketball%20sneaker%20in%20classic%20colorway%20displayed%20on%20dark%20wooden%20surface%20with%20spotlight%2C%20collector%20style%20photography%2C%20dramatic%20lighting%2C%20no%20text%20visible&width=800&height=500&seq=artc-grid-07&orientation=landscape"
  },
  {
    title: "Hoobuy Spreadsheet Brasil: Guia para Iniciantes",
    url: "/hoobuy-brasil-iniciantes",
    imageUrl: "https://readdy.ai/api/search-image?query=Brazilian%20flag%20colors%20reflected%20on%20a%20glossy%20white%20surface%20next%20to%20minimal%20fashion%20accessories%2C%20clean%20editorial%20lighting%2C%20sophisticated%20composition%2C%20no%20text&width=800&height=500&seq=artc-grid-08&orientation=landscape"
  },
  {
    title: "Como Economizar com o Hoobuy Spreadsheet",
    url: "/economizar-hoobuy-spreadsheet",
    imageUrl: "https://readdy.ai/api/search-image?query=Glass%20jar%20filled%20with%20golden%20coins%20next%20to%20luxury%20fashion%20items%20on%20marble%20surface%2C%20warm%20golden%20light%2C%20wealth%20concept%20photography%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=artc-grid-09&orientation=landscape"
  },
  {
    title: "Hoobuy vs CNFans: Comparativo Completo",
    url: "/hoobuy-vs-cnfans",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20luxury%20watches%20side%20by%20side%20on%20dark%20slate%20surface%2C%20reflection%20visible%2C%20premium%20comparison%20concept%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=artc-grid-10&orientation=landscape"
  },
  {
    title: "Top 10 Produtos Mais Vendidos no Hoobuy",
    url: "/top-produtos-hoobuy",
    imageUrl: "https://readdy.ai/api/search-image?query=Three%20luxury%20fashion%20boxes%20stacked%20elegantly%20with%20ribbon%20on%20white%20background%2C%20soft%20natural%20light%2C%20minimal%20product%20photography%2C%20gift%20concept%2C%20clean%20composition%2C%20no%20text&width=800&height=500&seq=artc-grid-11&orientation=landscape"
  },
  {
    title: "Erros Comuns ao Usar Hoobuy e Como Evitar",
    url: "/erros-comuns-hoobuy",
    imageUrl: "https://readdy.ai/api/search-image?query=Red%20warning%20sign%20reflected%20on%20glossy%20white%20surface%20with%20luxury%20handbag%20nearby%2C%20soft%20dramatic%20lighting%2C%20editorial%20concept%20photography%2C%20minimal%20style%2C%20no%20text&width=800&height=500&seq=artc-grid-12&orientation=landscape"
  },
];

export default function ArticlesSection() {
  return (
    <section id="articles" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            Últimos
          </h2>
          <p className="text-base text-foreground-500 font-serif italic">Artigos</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {articles.map((article) => (
            <Link
              key={article.url}
              to={article.url}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              <div className="h-40 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold font-heading text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <div className="mt-3 flex items-center gap-1.5">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm text-primary-500 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                  <span className="text-xs text-foreground-500">Ler artigo</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}